// Live's built-in devices by name — what `insertDevice` can create (the SDK
// inserts only Live's own devices; third-party plug-ins cannot be loaded
// this way). Names as Live's browser spells them. A lane's kind decides what
// makes sense: an instrument goes on a MIDI lane, audio effects on either.

export const AUDIO_EFFECTS: readonly string[] = [
  "Auto Filter",
  "Auto Pan",
  "Beat Repeat",
  "Channel EQ",
  "Chorus-Ensemble",
  "Compressor",
  "Delay",
  "Drum Buss",
  "Echo",
  "EQ Eight",
  "EQ Three",
  "Erosion",
  "Filter Delay",
  "Gate",
  "Glue Compressor",
  "Grain Delay",
  "Hybrid Reverb",
  "Limiter",
  "Multiband Dynamics",
  "Overdrive",
  "Pedal",
  "Phaser-Flanger",
  "Redux",
  "Reverb",
  "Roar",
  "Saturator",
  "Shifter",
  "Utility",
  "Vinyl Distortion",
];

export const MIDI_EFFECTS: readonly string[] = ["Arpeggiator", "Chord", "Note Length", "Pitch", "Random", "Scale", "Velocity"];

export const INSTRUMENTS: readonly string[] = [
  "Analog",
  "Collision",
  "Drift",
  "Drum Rack",
  "Electric",
  "Impulse",
  "Meld",
  "Operator",
  "Sampler",
  "Simpler",
  "Tension",
  "Wavetable",
];

/** The catalog for a lane, grouped as the picker shows it. */
export function deviceCatalog(kind: "audio" | "midi"): Array<{ group: string; names: readonly string[] }> {
  return kind === "midi"
    ? [
        { group: "Instruments", names: INSTRUMENTS },
        { group: "MIDI effects", names: MIDI_EFFECTS },
        { group: "Audio effects", names: AUDIO_EFFECTS },
      ]
    : [{ group: "Audio effects", names: AUDIO_EFFECTS }];
}
